<template>
	<div class="menuList">
		<el-menu ref="elMenu" unique-opened router class="el-menu-vertical-demo" @select='selectmenu' :default-active="activeIndex" @open="handleOpen" @close="handleClose"
			background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
			<MenuTree :dataList="dataList"></MenuTree>
		</el-menu>
		<div title="客服" class="borBox" :class="{borBoxAct:dragging}" v-bind:style="style"
			@mousedown.stop.prevent="onMouseDown" @mouseup.stop.prevent="onMouseup" @click="toOpen"></div>
	</div>
</template>

<script>
	import MenuTree from './MenuTree.vue'
	import {menuData} from "@/assets/js/data.js"
	export default {
		name: 'menuList',
		components: {
			MenuTree
		},
		data() {
			return {
				activeIndex:"/hitchManage",
				dataList: [
				],
				style: {
					top: "400px",
					left: "10px",
				},
				dragging: false,
				mouse: {
					x: 0,
					y: 0
				},
				noclick: true
			}
		},
		created() {
			this.$set(this.style,"left",(window.innerWidth-50)+"px")
			this.$set(this.style,"top",(window.innerHeight-100)+"px")
			this.getMenu()
			console.log("当前地址",this.$route.path)
			this.$set(this,"activeIndex",this.$route.path)
		},
		mounted() {
			let that = this
			let app = document.getElementById("app")
			app.addEventListener("mousemove", function(e) {
				if (that.dragging) {
					that.noclick = false
					var dx = e.clientX - that.mouse.x;
					var dy = e.clientY - that.mouse.y;
					that.style.top = parseInt(that.style.top) + dy + "px";
					that.style.left = parseInt(that.style.left) + dx + "px";
					that.mouse.x = e.clientX;
					that.mouse.y = e.clientY;
				}
			})
		},
		methods: {
			toOpen() {
				if ((this.noclick)) {
					window.open("https://mpkf.weixin.qq.com/")
				}
			},
			onMouseDown(e) {
			
				this.dragging = true;
				this.mouse.x = e.clientX;
				this.mouse.y = e.clientY;
			},
			onMouseup(e) {
			
				this.dragging = false;
				if (parseInt(this.style.left) <= 2) {
					this.style.left = "2px"
				}
				if (parseInt(this.style.left) > window.innerWidth - 50) {
					this.style.left = (window.innerWidth - 52) + "px"
				}
				if (parseInt(this.style.top) <= 2) {
					this.style.top = "2px"
				}
				if (parseInt(this.style.top) > window.innerHeight - 50) {
					this.style.top = (window.innerHeight - 52) + "px"
				}
				setTimeout(() => {
					this.noclick = true
				}, 100)
			},
			getMenu(arr){
				let menuL=JSON.parse(localStorage.getItem("menuL"))
				console.log(menuData)
				this.$set(this,"dataList",menuL)
			},
			selectmenu(index,indexPath){
				this.activeIndex=index
			},
			handleOpen(key, keyPath) {
				// console.log('open key: ', key, 'open keyPath: ', keyPath);
			},
			handleClose(key, keyPath) {
				// console.log('close key: ', key, 'close keyPath: ', keyPath);
			}
		}
	}
</script>
<style lang="scss" scoped>
	.menuList{
		/deep/.custom-menu-tree{
			.el-submenu{
				position: relative;
				height: 40px;
				width: 180px;
				line-height: 40px;
				.el-submenu__title{
					// background: #324450!important;
					color: #324450!important;
					font-weight: 700;
					background-color: #daf2ea!important;
					height: 40px;
					font-size: 13px;
					line-height: 40px;
					letter-spacing: 1px;
				}
				.el-menu--inline{
					background-color: #daf2ea!important;
				}
			}
			.el-menu-item{
				height: 40px;
				width: 180px;
				line-height: 40px;
				font-size: 13px;
				letter-spacing: 1px;
				color: #324450!important;
				font-weight: 700;
				// background: #324450!important;
				background-color: #daf2ea!important;
				min-width: auto;
			} 
			.el-menu-item:hover{
				background: #a2e5ca!important;
			}
			.is-active:hover{
				background: #03adac!important;
				color: #fff!important;
			}
			.is-active{
				// background: #324450!important;
				background: #03adac!important;
				color: #fff!important;
			}
			.is-active::before{
				content: "";
				position: absolute;
				left: 0;
				top: 0;
				display: block;
				width: 2px;
				height: 100%;
				background: #ffd04b;
			}
		}
	}
	.borBox {
		cursor: pointer;
		user-select: none;
		width: 50px;
		height: 50px;
		position: fixed;
		border-radius: 50%;
		background: #74beff url("../assets/img/icon/lsfk.png")no-repeat center;
		background-size: 55%;
		z-index: 10000;
		box-shadow: 0 0 15px 0  #5987e0 inset, 0 0 6px #d9d3d3;
	}
	
	.borBox:hover {
		width: 70px;
		height: 70px;
	}
	
	.borBoxAct {
		background-color: #66a8e1;
	}
</style>
